import { createSelector } from "reselect";

export function createPagesRootSelector(resourceSelector) {
  return createSelector(
    resourceSelector,
    resource => resource.pages
  );
}
